import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Steps from "./components/Steps";
import HotBoard from "./components/HotBoard";
import FollowUp from "./components/FollowUp";
import Channels from "./components/Channels";
import Topics from "./components/Topics";
import Faq from "./components/Faq";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50 text-foreground-900">
      <Navbar />
      <main>
        <Hero />
        <Steps />
        <HotBoard />
        <FollowUp />
        <Channels />
        <Topics />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}